import { isBoolean } from 'es-toolkit/compat'

export default isBoolean
